import { useMemo } from 'react';
import { RawTrack, useGetRawTracks } from '@customer/store/apis/investigationsApi';
import { useAppSelector } from '@customer/store/hooks';
import { useParams } from 'react-router-dom';
import { useInvestigationEntity } from '@customer/store/slices/investigationsSlice';

export const useRawTrackRows = (): RawTrack[] => {
  const { investigationId } = useParams();
  const siteId = useAppSelector(state => state.auth.siteId);

  const { investigation, rawTracks } = useGetRawTracks({
    siteId,
    investigationId,
  });

  const { hiddenAssetIds } = useInvestigationEntity({
    siteId,
    investigationId,
  });

  // Check the rawTracks agains the list of hidden asset IDs.
  const displayTracks = useMemo<RawTrack[]>(() => {
    let visibleTracks: RawTrack[] = [];

    if (investigation && rawTracks?.length) {
      visibleTracks = rawTracks.filter(({ assetId }) => !hiddenAssetIds?.includes(assetId));
    }

    return visibleTracks;
  }, [investigation, rawTracks, hiddenAssetIds]);

  return displayTracks;
};

export default useRawTrackRows;
